const $0d4230ba56185297$export$19b7830a58b33f46 = (()=>{
    const states = {};
    const scripts = {};
    const track = {};
    const routes = [];
    const setState = (stateName, _states)=>{
        states[stateName] = {
            ...states[stateName],
            ..._states
        };
        if (track.start) track.start();
    };
    const setScript = (scriptName, _scripts)=>{
        scripts[scriptName] = {
            ...scripts[scriptName],
            ..._scripts
        };
    };
    const visitedPaths = new Set();
    function router(event, path) {
        let absolutePath = path;
        if (event) event.preventDefault();
        if (path !== window.location.pathname) {
            visitedPaths.add(path);
            if (absolutePath.charAt(0) !== "/") {
                const b = window.history.pushState(null, null, "/" + path);
            } else {
                const b = window.history.pushState(null, null, path);
            }
            $0d4230ba56185297$export$19b7830a58b33f46.track.start();
        }
    // navigateTo(path);
    }
    function navigate() {}
    // function navigateTo(path) {
    //   // Perform custom logic based on the path
    //   console.log('Navigating to:', path);
    //   // Simulate loading content based on the path
    //   const contentElement = document.getElementById('test');
    //   contentElement.innerHTML = getContent(path);
    // }
    // Handle initial route when the page loads
    // window.addEventListener('load', () => {
    //   const initialPath = window.location.pathname;
    //   Kori.track.start();
    //   // navigateTo(initialPath);
    // });
    window.addEventListener("popstate", ()=>{
        const currentPath = window.location.pathname;
        if (visitedPaths.length > 0) $0d4230ba56185297$export$19b7830a58b33f46.track.start();
        $0d4230ba56185297$export$19b7830a58b33f46.track.start();
    // navigateTo(currentPath);
    });
    return {
        track: track,
        states: states,
        scripts: scripts,
        router: router,
        setState: setState,
        setScript: setScript
    };
})();
const { states: $0d4230ba56185297$export$b782dad1d219cf26, setState: $0d4230ba56185297$export$42fffed799c298bb, setScript: $0d4230ba56185297$export$2b9643fc53d6469b, router: $0d4230ba56185297$export$5375cda95f0b0eb4 } = $0d4230ba56185297$export$19b7830a58b33f46;
var $0d4230ba56185297$export$2e2bcd8739ae039 = $0d4230ba56185297$export$19b7830a58b33f46;


function $1ae97e72b61d2374$var$isValidTagName(tagName) {
    const tagPattern = /^[a-zA-Z][a-zA-Z0-9-]*$/;
    return tagPattern.test(tagName);
}
function $1ae97e72b61d2374$var$render_element({ tagName: tagName, attribs: attribs, children: children }) {
    if ($1ae97e72b61d2374$var$isValidTagName(tagName)) {
        const element = document.createElement(tagName);
        if (attribs) for (const [key, value] of Object.entries(attribs)){
            if (key === "if-click") element.addEventListener("click", (0, $0d4230ba56185297$export$2e2bcd8739ae039).scripts[value.split("-")[0]][value.split("-")[1]]);
            if (key === "if-change") element.addEventListener("input", (event)=>{
                const scriptFunction = (0, $0d4230ba56185297$export$2e2bcd8739ae039).scripts[value.split("-")[0]][value.split("-")[1]];
                if (event.target.value !== '<img src=x onerror=alert("Malicious Script")>') {
                    if (typeof scriptFunction === "function") scriptFunction(event);
                    else console.error("Invalid script function:", scriptFunction);
                } else scriptFunction("");
            });
            if (key === "href") element.addEventListener("click", (event)=>{
                const hrefValue = element.getAttribute("href");
                if (hrefValue) {
                    event.preventDefault(); // Prevent the default behavior of the link
                    const targetAttribute = element.getAttribute("target");
                    const hyphenIndex = hrefValue.indexOf("-");
                    const splitHref = [
                        hrefValue.substring(0, hyphenIndex),
                        hrefValue.substring(hyphenIndex + 1)
                    ];
                    if (splitHref[0] === "prevReload" && splitHref[1].length > 0) {
                        if (targetAttribute === "_blank") window.open(splitHref[1], "_blank");
                        else window.location.assign(splitHref[1]);
                    } else (0, $0d4230ba56185297$export$5375cda95f0b0eb4)(event, hrefValue);
                }
            });
            if (key === "if-focus") element.addEventListener("focus", (0, $0d4230ba56185297$export$2e2bcd8739ae039).scripts[value.split("-")[0]][value.split("-")[1]]);
            if (key === "if-blur") element.addEventListener("blur", (0, $0d4230ba56185297$export$2e2bcd8739ae039).scripts[value.split("-")[0]][value.split("-")[1]]);
            if (key === "if-submit") element.addEventListener("submit", (0, $0d4230ba56185297$export$2e2bcd8739ae039).scripts[value.split("-")[0]][value.split("-")[1]]);
            element.setAttribute(key, value);
        }
        if (children) for (const child of children){
            const ch = $1ae97e72b61d2374$var$render(child);
            element.appendChild(ch);
        }
        return element;
    }
}
const $1ae97e72b61d2374$var$render = (vNode)=>{
    if (typeof vNode === "string") return document.createTextNode(vNode);
    return $1ae97e72b61d2374$var$render_element(vNode);
};
var $1ae97e72b61d2374$export$2e2bcd8739ae039 = $1ae97e72b61d2374$var$render;


var $5fed3ec5398ad2d0$export$2e2bcd8739ae039 = (realNode, realTarget)=>{
    realTarget.replaceChildren(realNode);
    return realNode;
};



const $be0f08cdfe6eb2e3$var$zip = (xs, ys)=>{
    const zipped = [];
    for(let i = 0; i < Math.max(xs.length, ys.length); i++)zipped.push([
        xs[i],
        ys[i]
    ]);
    return zipped;
};
const $be0f08cdfe6eb2e3$var$diffAttrs = (oldAttrs, newAttrs)=>{
    const patches = [];
    // set new attributes
    for (const [k, v] of Object.entries(newAttrs))patches.push(($node)=>{
        $node.setAttribute(k, v);
        return $node;
    });
    // remove old attributes
    for(const k in oldAttrs)if (!(k in newAttrs)) patches.push(($node)=>{
        $node.removeAttribute(k);
        return $node;
    });
    return ($node)=>{
        for (const patch of patches)patch($node);
    };
};
const $be0f08cdfe6eb2e3$var$diffChildren = (oldVChildren, newVChildren)=>{
    const childPatches = [];
    oldVChildren.forEach((oldVChild, i)=>{
        childPatches.push($be0f08cdfe6eb2e3$var$diff(oldVChild, newVChildren[i]));
    });
    const additionalPatches = [];
    for (const additionalVChild of newVChildren.slice(oldVChildren.length))additionalPatches.push(($node)=>{
        $node.appendChild((0, $1ae97e72b61d2374$export$2e2bcd8739ae039)(additionalVChild));
        return $node;
    });
    return ($parent)=>{
        for (const [patch, child] of $be0f08cdfe6eb2e3$var$zip(childPatches, $parent.childNodes)){
            if (typeof patch === "undefined") return undefined;
            patch(child);
        }
        for (const patch of additionalPatches)patch($parent);
        return $parent;
    };
};
const $be0f08cdfe6eb2e3$var$diff = (vOldNode, vNewNode)=>{
    if (vNewNode === undefined) return ($node)=>{
        if ($node !== undefined) $node.remove();
        return undefined;
    };
    if (typeof vOldNode === "string" || typeof vNewNode === "string") {
        if (vOldNode !== vNewNode) return ($node)=>{
            const $newNode = (0, $1ae97e72b61d2374$export$2e2bcd8739ae039)(vNewNode);
            $node.replaceWith($newNode);
            return $newNode;
        };
        else return ($node)=>undefined;
    }
    if (vOldNode.tagName !== vNewNode.tagName) return ($node)=>{
        const $newNode = (0, $1ae97e72b61d2374$export$2e2bcd8739ae039)(vNewNode);
        $node.replaceWith($newNode);
        return $newNode;
    };
    const patchAttrs = $be0f08cdfe6eb2e3$var$diffAttrs(vOldNode.attribs, vNewNode.attribs);
    const patchChildren = $be0f08cdfe6eb2e3$var$diffChildren(vOldNode.children, vNewNode.children);
    return ($node)=>{
        patchAttrs($node);
        patchChildren($node);
        return $node;
    };
};
var $be0f08cdfe6eb2e3$export$2e2bcd8739ae039 = $be0f08cdfe6eb2e3$var$diff;


function $efb5c0fd3ddbf6a4$var$getAttrib(element) {
    if (element.attributes === undefined) return;
    const attribs = {};
    for(let i = 0; i < element.attributes.length; i++){
        const attribute = element.attributes[i];
        attribs[attribute.name] = attribute.value;
    }
    return attribs;
}
function $efb5c0fd3ddbf6a4$var$formatHTML(DOM_STRING_REPRESENTATION) {
    const withoutNewlines = DOM_STRING_REPRESENTATION.replace(/(\n|\r|\r\n){2,}/g, "\n").trim();
    const withoutSpacesBetweenTags = withoutNewlines.replace(/>\s+</g, "><");
    return withoutSpacesBetweenTags;
}
function $efb5c0fd3ddbf6a4$var$processNode(node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
        const vDOM = {
            tagName: node.tagName.toLowerCase(),
            attribs: $efb5c0fd3ddbf6a4$var$getAttrib(node),
            children: []
        };
        for(let i = 0; i < node.childNodes.length; i++){
            // console.log(node.childNodes[i].data)
            const childNode = node.childNodes[i];
            vDOM.children.push($efb5c0fd3ddbf6a4$var$processNode(childNode));
        }
        return vDOM;
    } else if (node.nodeType === Node.TEXT_NODE) return node.nodeValue.trim();
    return null;
}
function $efb5c0fd3ddbf6a4$export$2e2bcd8739ae039(html) {
    for(let index = 0; index < html.length; index++){
        let char = html[index];
    // console.log(char)
    // if (char === '{') {
    //  while (char !== '}') {
    //   const current = html[index + 1]
    //   char = current
    //   console.log(current)
    //  }
    //  console.log(char)
    // }
    }
    const parser = new DOMParser();
    const document = parser.parseFromString(html, "text/html");
    /**
  * Old implementation - Appending to temporary HTML
  * const tempContainer = document.createElement('div')
  * tempContainer.innerHTML = formatHTML(html)
  */ if (document !== null) {
        // setTimeout(() => {
        //  // console.log(document)
        // }, 5000);
        const vDom = $efb5c0fd3ddbf6a4$var$processNode(document.body.firstChild);
        if (vDom !== null) document.documentElement.innerHTML = "";
        // console.log(vDom)
        return vDom;
    }
}





const $71a50f4cf94a37e4$export$7adf1129287272e5 = (data)=>{
    const splitString = data.split(" ");
    return splitString;
};



const $90129c5a1138031d$export$fbd7dcc4b31c269b = (command)=>{
    const commandLists = {
        "goto": "Go to",
        "display": "Display",
        "play": "Play",
        "clear": "Clear",
        "help": "Help"
    };
    return commandLists[(0, $71a50f4cf94a37e4$export$7adf1129287272e5)(command)[0]] ? true : false;
};


const $b11e3f3d99810540$export$24a5775c8c69f6fc = (Display)=>{
    const Pages = [
        {
            name: "About",
            path: "/about",
            desc: "About me page"
        },
        {
            name: "Projects",
            path: "/projects",
            desc: "Project Page"
        }
    ];
    const Games = [
        {
            name: "Snake",
            path: "/games/snakes",
            desc: "A Simple Snake Game"
        },
        {
            name: "Projects",
            path: "/projects",
            desc: "Project Page"
        }
    ];
    const Projects = [
        {
            name: "eBextractor",
            repo: "",
            live: "https://chromewebstore.google.com/detail/ikfpolbfdnihjnadfodochmagdagpbik",
            desc: `
  \u{1F50D} The eBay Search Data Extraction Extension offers data analysis 
      for single-page search results, providing valuable insights through the following features:

- \u{1F4B0} Highest Price: Obtain the maximum price observed in the search results.
- \u{1F4B5} Lowest Price: Identify the minimum price found among the listings.
- \u{1F4CA} Average Price: Calculate the mean price across the search results.
- \u{1F3AF} Middle Price: Determine the median price, offering a representative value.
- \u{1F511} Keyword Occurrence: Track and quantify the frequency of each keyword throughout the listings.
- \u{1F4B2} Price Occurrence: Gain an understanding of how often different price points appear in the search results.
  `
        },
        {
            name: "eBex - API",
            repo: "https://github.com/koribot/ebextractor-api-flask",
            live: "https://ebextractor-v1.vercel.app/api/extract/using_keyword?q=shoes",
            desc: `
   API that is intended for my ebextractor but it is a free to use API
  `
        },
        {
            name: "koribotJS",
            repo: "https://github.com/koribot/koribotJS",
            live: "#",
            desc: `
    koribotJS is a hobby project, it is unoptimized, messy Component Based 
    Javascript framework/library. 
    - It uses diffing, patching and rendering algorigthm
    - It has a globalize state manager that is persistent until reload of the browser
    - a simple routing
    

     This portfolio is powered by it. 
  `
        },
        {
            name: "eBex Web Scraper",
            repo: "https://github.com/koribot/ebex-scraper-web",
            live: "https://ebex-scraper-web.vercel.app",
            desc: `
      A nextjs web version of my chrome extension - UNDER \u{1F6A7}. `
        },
        {
            name: "Waan Trading - Ecommerce",
            repo: "https://github.com/koribot/waantrading-react",
            live: "https://waantrading-react.vercel.app",
            desc: `
      A simple ecommerce website using react - UNDER \u{1F6A7}. `
        },
        {
            name: "Internship Project - ACS-MEDISKIN-WEB",
            desc: `
      My Intership Project - React, TypeScript`
        }
    ];
    const lists = {
        pages: Pages,
        projects: Projects
    };
    return `
  ${lists[Display] ? `<div class='wrapper'>
  <h1 class='text-white'>${Display}</h1>
    <table class='custom-table'>
       <thead>
         <tr>
           <th class='text-white'>Name</th>
           ${Display === "projects" ? `
         <th class='text-white'>Repo</th>
         <th class='text-white'>Live</th>
         ` : `
         <th class='text-white'>path</th>
         `}
      <th class='text-white'>Description</th>

           
         </tr>
       </thead>
       <tbody class='overflow-x-auto'>
         ${lists[Display].map((items)=>`
           <tr>
             <td class='text-white'>${items.name}</td>
             ${Display === "projects" ? `
            <td class='text-white'>
            <a href=${items.name !== "eBextractor" && items.name !== "Internship Project - ACS-MEDISKIN-WEB" ? `prevReload-${items.repo}` : "#"} target='_blank'>
            ${items.name !== "eBextractor" ? `Click` : "Repo is Private"}
            </a>
           </td>
           <td class='text-white'>
           <a href=${items.name !== "koribotJS" && items.name !== "Internship Project - ACS-MEDISKIN-WEB" ? `prevReload-${items.live}` : "#"} target='_blank'>
           ${items.name !== "koribotJS" ? `Click` : "No WebSite Yet"}
           </a>
           </td>
            ` : `
            <td class='text-white'>
            ${items.path}
           </td>
            `}
            
             <td class='text-white'><pre>${items.desc}</pre></td>
           </tr>
         `).join("")}
       </tbody>
     </table>
  </div>` : ""}
 `;
};
var $b11e3f3d99810540$export$2e2bcd8739ae039 = $b11e3f3d99810540$export$24a5775c8c69f6fc;


(0, $0d4230ba56185297$export$42fffed799c298bb)("CmdDisplay", {
    isFocus: false,
    isBlur: true,
    isInputHasValue: false,
    inputValue: "",
    commands: [
        "Help",
        "Go to",
        "Display *"
    ],
    commandLists: [
        {
            command: "Goto",
            desc: "Go to pages",
            eg: "Goto /"
        },
        {
            command: "Display",
            desc: "Display lists of Options[Pages, Projects]",
            eg: "Display Pages"
        },
        // { command: 'Play', desc: 'Play a game', eg: 'Play Snake' },
        {
            command: "Clear",
            desc: "Clear Console",
            eg: "Clear"
        },
        {
            command: "Resume",
            desc: "Access My Resume",
            eg: "Resume"
        },
        {
            command: "Cert",
            desc: "View All of my certificates (can also be access using goto certificates)",
            eg: "Cert"
        },
        {
            command: "github",
            desc: "My github account",
            eg: "github"
        }
    ],
    prefixLists: [
        "Pages",
        "Games",
        "Projects"
    ],
    resultLists: []
});
(0, $0d4230ba56185297$export$2b9643fc53d6469b)("CmdDisplay", {
    onChange: (e)=>{
        (0, $0d4230ba56185297$export$42fffed799c298bb)("CmdDisplay", {
            isInputHasValue: e.target.value.length > 0 ? true : false,
            inputValue: e.target.value
        });
    },
    onFocus: ()=>{
        (0, $0d4230ba56185297$export$42fffed799c298bb)("CmdDisplay", {
            isFocus: true,
            isBlur: false,
            isInputHasValue: true
        });
    },
    onBlur: (e)=>{
        (0, $0d4230ba56185297$export$42fffed799c298bb)("CmdDisplay", {
            isFocus: false,
            isBlur: true,
            isInputHasValue: e.target.value.length > 0 ? true : false
        });
    },
    submit: (e)=>{
        e.preventDefault();
        const targetValue = e.target[0].value.toLowerCase();
        if (targetValue === "resume") window.open("https://drive.google.com/file/d/111hkpKt6UJlWS5QnMoCpfnVXbQHAC6I3/view", "_blank");
        if ((0, $71a50f4cf94a37e4$export$7adf1129287272e5)(targetValue)[0] === "goto") (0, $0d4230ba56185297$export$5375cda95f0b0eb4)(null, (0, $71a50f4cf94a37e4$export$7adf1129287272e5)(targetValue)[1]);
        if (targetValue === "github") window.open("https://github.com/koribot", "_blank");
        if (targetValue === "cert") (0, $0d4230ba56185297$export$5375cda95f0b0eb4)(null, "certificates");
        const r = (0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.resultLists;
        if ((0, $90129c5a1138031d$export$fbd7dcc4b31c269b)(targetValue)) {
            if ((0, $71a50f4cf94a37e4$export$7adf1129287272e5)(targetValue)[0] === "display") r.push(targetValue);
        }
        if (targetValue === "clear") r.length = [];
        (0, $0d4230ba56185297$export$42fffed799c298bb)("CmdDisplay", {
            isInputHasValue: false,
            inputValue: targetValue,
            isFocus: false,
            isBlur: true,
            resultLists: r
        });
        e.target[0].value = "";
        e.target[0].focus();
        if ((0, $71a50f4cf94a37e4$export$7adf1129287272e5)(targetValue)[0] === "goto") (0, $0d4230ba56185297$export$5375cda95f0b0eb4)(null, (0, $71a50f4cf94a37e4$export$7adf1129287272e5)(targetValue)[1]);
    }
});
const $2e936ac5cc761cfa$export$f1d028635f3b6bad = ()=>{
    return `
   <div class='w-full h-full p-[50px] '>
    <div class='bg-[gray] p-[2px]'>
     <div class='bg-black p-5 min-h-[50px] flex text-white'>
      <div class='flex'>
       <span>~Kori~$</span> 
       <p class=${!(0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.isFocus && (0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.isBlur && !(0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.isInputHasValue ? `pre-text` : `hidden`}>
       \u{27BD}
       </p>
      </div>

      <div>
       <form if-submit='CmdDisplay-submit'>
         <input id='int'
         placeholder='Type here'
         if-change='CmdDisplay-onChange'
         if-blur='CmdDisplay-onBlur'
         if-focus='CmdDisplay-onFocus'
         class="custom-input ml-1 focus:outline-none text-white"
         >
       </form>
      </div>
     </div>

     <div class='flex flex-col gap-[20px] bg-black min-h-[200px] p-5 text-white'>
      
    ${(0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.resultLists.length > 0 ? (0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.resultLists.map((item)=>{
        return (0, $b11e3f3d99810540$export$2e2bcd8739ae039)((0, $71a50f4cf94a37e4$export$7adf1129287272e5)(item)[1]);
    }).join("") : ""}
     </div>
     </div>
   </div> 
 `;
};
var $2e936ac5cc761cfa$export$2e2bcd8739ae039 = $2e936ac5cc761cfa$export$f1d028635f3b6bad;


const $1235afba39e73349$export$a06f1c675e846f6f = ()=>{
    return `
  <footer class="py-4 text-white text-center">
    <div class="container mx-auto flex flex-col justify-center items-center">
      <p class="text-md">Created by Walid Cawasa &copy;</p>
      <span class="text-sm flex gap-[2px]">
      <p>Powered by</p> \u{1F525}<a class='underline' href='prevReload-https://github.com/koribot/koribotJS' target='_blank'>koribotJS</a>\u{1F525}
      </span>
    </div>
  </footer>
 `;
};
var $1235afba39e73349$export$2e2bcd8739ae039 = $1235afba39e73349$export$a06f1c675e846f6f;




(0, $0d4230ba56185297$export$42fffed799c298bb)("mode", {
    mode: window.localStorage.getItem("mode") ? window.localStorage.getItem("mode") : "cmd"
});
(0, $0d4230ba56185297$export$2b9643fc53d6469b)("mode", {
    switchMode: ()=>{
        window.localStorage.setItem("mode", (0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? "normal" : "cmd");
        const currentMode = window.localStorage.getItem("mode");
        // window.localStorage.setItem()
        (0, $0d4230ba56185297$export$42fffed799c298bb)("mode", {
            mode: currentMode ? currentMode : "cmd"
        });
    }
});
const $6bd3eda98fbd2e39$export$549ff81930776885 = ()=>{
    return `
 <div class='switch-container'>
 <label class='switch-label flex flex-col p-2'>
   <input ${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? "" : "checked"} type='checkbox' class='switch-input' if-click='mode-switchMode' />
   <div class='switch-slider'>
     <div class='slider-thumb'></div>
   </div>
   <span class='ml-2 text-white'>${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode !== "cmd" ? "normal" : "cmd"}</span>
 </label>
</div>
 `;
};



function $8b9e3ac52b1631c9$export$2e2bcd8739ae039(targetElement, paddingOffset = 0, ms = 200) {
    const targetTop = targetElement.getBoundingClientRect().top + window.scrollY - paddingOffset;
    const startPosition = window.scrollY;
    const distance = targetTop - startPosition;
    const duration = ms; // You can adjust the duration as needed
    let startTime;
    function scrollAnimation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const scrollProgress = Math.min(timeElapsed / duration, 1);
        window.scrollTo(0, startPosition + distance * scrollProgress);
        if (timeElapsed < duration) window.requestAnimationFrame(scrollAnimation);
    }
    window.requestAnimationFrame(scrollAnimation);
}




const $aa45b3c23d9f4312$export$393edc798c47379d = ()=>{
    return `
   <div class='flex justify-center mt-[50px] w-[100%]'>
   <div class='wrapper'>
     <h1 class='text-white'>Options (not case-sensitive)</h1>
     <table class='custom-table'>
        <thead>
          <tr>
            <th class='text-white'>Command</th>
            <th class='text-white'>Description</th>
            <th class='text-white'>Usage</th>
          </tr>
        </thead>
        <tbody>
          ${(0, $0d4230ba56185297$export$b782dad1d219cf26).CmdDisplay.commandLists.map((items)=>`
            <tr>
              <td class='text-white'>${items.command}</td>
              <td class='text-white'>${items.desc}</td>
              <td class='text-white'>${items.eg}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>
   </div>
 `;
};


(0, $0d4230ba56185297$export$42fffed799c298bb)("navbar", {
    open: false
});
(0, $0d4230ba56185297$export$2b9643fc53d6469b)("navbar", {
    openMenu: ()=>{
        const current = (0, $0d4230ba56185297$export$b782dad1d219cf26).navbar.open;
        (0, $0d4230ba56185297$export$42fffed799c298bb)("navbar", {
            open: current ? false : true
        });
    },
    aboutClick: ()=>{
        const aboutElement = document.querySelector('div[ref="about"]');
        if (aboutElement) (0, $8b9e3ac52b1631c9$export$2e2bcd8739ae039)(aboutElement, 80, 200);
    },
    projectsClick: ()=>{
        const projectsElement = document.querySelector('div[ref="projects"]');
        if (projectsElement) (0, $8b9e3ac52b1631c9$export$2e2bcd8739ae039)(projectsElement, 160, 300);
    },
    contactClick: ()=>{
        const contactElement = document.querySelector('div[ref="contact"]');
        if (contactElement) (0, $8b9e3ac52b1631c9$export$2e2bcd8739ae039)(contactElement, 160, 400);
    },
    certificatesClick: ()=>{
        const contactElement = document.querySelector('div[ref="certificates"]');
        if (contactElement) (0, $8b9e3ac52b1631c9$export$2e2bcd8739ae039)(contactElement, 160, 400);
    }
});
const $c39e3576846451ff$export$42cfbb80f7861e77 = ()=>{
    return `
${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? `<div class='p-[50px] text-center'>
                    <h1 class='text-[50px] text-white'>
                    \u{2728}Welcome\u{2728}
                    </h1>  
                    <h1 class='text-[15px] text-[gray]'>
                    ~~~This mode is only available for web not on mobile~~~
                    </h1>
                    ${(0, $aa45b3c23d9f4312$export$393edc798c47379d)()}   
            </div> ` : `
     
            <nav class="bg-gray-800 p-4 flex justify-center">
                <div class="flex items-center justify-between">
                <button class="text-white focus:outline-none lg:hidden" id="mobile-menu-btn">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
                    </svg>
                </button>
                
                <ul class="hidden lg:flex space-x-4 text-white">
                    <li if-click='navbar-aboutClick' class="cursor-pointer hover:text-gray-300">About</li>
                    <li if-click='navbar-projectsClick' class="cursor-pointer hover:text-gray-300">Projects</li>
                    <li if-click='navbar-contactClick' class="cursor-pointer hover:text-gray-300">Contact</li>
                    <a 
                    href='prevReload-https://drive.google.com/file/d/111hkpKt6UJlWS5QnMoCpfnVXbQHAC6I3/view' 
                    class="cursor-pointer hover:text-gray-300"
                    target='_blank'
                    >
                    Resume
                    </a>
                    <li if-click='navbar-certificatesClick' class="cursor-pointer block text-white">Certificates</li>
                    <a 
                        href='prevReload-https://github.com/koribot' 
                        class="cursor-pointer block text-white"
                        target='_blank'
                    >
                    Github
                    </a>
                </ul>
                </div>
            </nav>

            <div class="lg:hidden" id="mobile-menu">
                <button if-click='navbar-openMenu' id="burger-icon" class="absolute top-[0px] left-1 text-[50px] text-white focus:outline-none">
                 ${(0, $0d4230ba56185297$export$b782dad1d219cf26).navbar.open ? `<p class='ml-[5px] absolute top-[0px] left-1 text-[30px]'>X</p>` : `<img class='object-contain w-[60px] h-[50px]' src='public/burger-icon.png'/>`}
                </button>
            
                <ul id="mobile-menu-items" class="${(0, $0d4230ba56185297$export$b782dad1d219cf26).navbar.open ? "block" : "hidden"} bg-gray-800 p-2 space-y-2 flex flex-col justify-center items-center">
                <li if-click='navbar-aboutClick' class="cursor-pointer block text-white">About</li>
                <li if-click='navbar-projectsClick' class="cursor-pointer block text-white">Projects</li>
                <li if-click='navbar-contactClick' class="cursor-pointer block text-white">Contact</li>
                <a 
                    href='prevReload-https://drive.google.com/file/d/1LCpzMEJshy-41bDaE8685Vd10mphbTui/view?usp=sharing' 
                    class="cursor-pointer block text-white"
                    target='_blank'
                    >
                    Resume
                </a>
                <li if-click='navbar-certificatesClick' class="cursor-pointer block text-white">Certificates</li>
                <a 
                    href='prevReload-https://github.com/koribot' 
                    class="cursor-pointer block text-white"
                    target='_blank'
                >
                Github
                </a>
                </ul>
            </div>
`}  
 `;
};
var $c39e3576846451ff$export$2e2bcd8739ae039 = $c39e3576846451ff$export$42cfbb80f7861e77;




function $9549e6d5a5d3e77f$export$2e2bcd8739ae039() {
    function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }
    function scroll() {
        const currentPosition = window.scrollY;
        const targetPosition = 0;
        const duration = 1000; // Adjust the duration as needed
        function animate(currentTime) {
            const timeElapsed = currentTime - startTime;
            const progress = timeElapsed / duration;
            window.scrollTo(0, easeInOutQuad(progress, currentPosition, targetPosition - currentPosition, 1));
            if (timeElapsed < duration) window.requestAnimationFrame(animate);
        }
        let startTime = null;
        window.requestAnimationFrame(function(currentTime) {
            startTime = currentTime;
            animate(currentTime);
        });
    }
    // Call scroll inside requestAnimationFrame
    window.requestAnimationFrame(scroll);
}


const $b0bcef696ab6225e$export$21a5ca8aa77d35ff = (data)=>{
    return String(data).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
};
var $b0bcef696ab6225e$export$2e2bcd8739ae039 = $b0bcef696ab6225e$export$21a5ca8aa77d35ff;






(0, $0d4230ba56185297$export$2b9643fc53d6469b)("image_modal", {
    closeModal: ()=>{
        $306a0a41b901215e$export$4df28e2bd734bd04();
    }
});
function $306a0a41b901215e$export$59f23549a9ebdada(src, w = 600, h = 500) {
    const check = document.getElementById("image_modal");
    if (check === null) {
        const modal = document.createElement("div");
        modal.id = "image_modal";
        const modalUI = `
   <div class="modal-container p-[50px] lg:p-0 overflow-hidden">
     <div class="relative bg-white p-8 rounded shadow-md ">
       <p if-click='image_modal-closeModal' class='absolute top-0 right-5 text-[30px] cursor-pointer'>X</p>
         <div>
          <img class='w-full lg:w-[${w}px] lg:h-[${h}px] object-contain ' src=${src}/>
         </div>
     </div>
   </div>
  
  `;
        modal.appendChild((0, $1ae97e72b61d2374$export$2e2bcd8739ae039)((0, $efb5c0fd3ddbf6a4$export$2e2bcd8739ae039)(modalUI)));
        document.body.appendChild(modal);
    }
    // need to return something so it wont be undefined on the UI
    return "";
}
function $306a0a41b901215e$export$4df28e2bd734bd04() {
    const image_modal = document.getElementById("image_modal");
    document.body.removeChild(image_modal);
    return "";
}


(0, $0d4230ba56185297$export$2b9643fc53d6469b)("normalDisplay", {
    scrollToTop: ()=>{
        (0, $9549e6d5a5d3e77f$export$2e2bcd8739ae039)();
    },
    openModal: ()=>{
        (0, $306a0a41b901215e$export$59f23549a9ebdada)("public/ADUKASYON-CERTIFICATE.png");
    }
});
const $9888e359c105ea28$export$839b001adf59c171 = ()=>{
    return `
  <div>
  <div class='separator-nav'>
  </div>
   <div class='px-[20px] lg:px-[60px] flex justify-center gap-[100px]'>
      <div class='border rounded border-gray-600 text-white flex p-[10px] lg:p-[50px]'>
        <div ref='about' class="text-white flex flex-col gap-5 font-Helvetica">
          <div class='block md:hidden flex justify-center'>
            <img class='w-[150px]' src='public/walid-cawasa-profile.png'/>
          </div>

          <div class="flex flex-col mb-5 gap-5">
            <h1 class="text-sm lg:text-4xl  flex">
            ${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("<Hello>")}
            <span class="ml-2 wave">\u{1F44B}\u{1F3FB}</span>
            </h1>
            <h1 class="text-sm lg:text-2xl font-bold ml-5">I am Walid Labawan Cawasa</h1>
            <p class="lg:text-lg ml-5" >- I am an aspiring web developer</p>
            <p class="lg:text-lg ml-5">- I like to build stuffs</p>
            <h1 class="text-sm lg:text-2xl flex mb-5">
            ${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("</Hello>")}
            </h1>
          </div>

          <div>
            <h1 class="text-sm lg:text-2xl  flex mb-5">
              ${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("<Tech Stack>")}
            </h1>
            <span class='grid grid-cols-3 grid-rows-2 gap-5 lg:flex'>
              <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/css.png'/>
              <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/tailwind.png'/>
              <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/html.png'/>
              <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/jscript.png'/>
              <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/react.png'/>
              <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/nextjs.png'/>
            <img class='w-[50px] h-[50px] rotate-horizontal-animation' src='public/python.png'/>
            </span>

            <h1 class="text-sm lg:text-2xl flex mt-5">
              ${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("</Tech Stack>")}
            </h1>
          </div>
          <p class="mt-[15px] italic text-lg">"Not the brightest but resourceful"</p>
        </div>
  
        <div class='overflow-hidden hidden md:block lg:block'>
          <img class='slide-in-from-right' src='public/walid-cawasa-profile2.jpg'/>
        </div>
      </div>
   </div>
   <div class='separator'> 
   </div>
   <div ref='projects' class='px-[20px] lg:px-[60px] flex flex-col text-center justify-center items-center gap-5'>
    <div class='border border-gray-600 rounded p-[15px]'>
          <h1 class='text-white lg:text-2xl'>${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("<Projects>")}</h1>
          <div class='text-white grid lg:flex gap-5'>
            <div class='flex flex-col justify-start items-center'>
              <span class='hover:bg-gray-600 p-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                <img class='object-contain w-[400px] h-[200px]' src='public/ebextractor.png'/>
              <p>eBextractor - chrome extension</p>
              <p class="italic text-lg">"eBay search data extractor: High, Low, Avg, </br>Mid prices + keyword count & price occurrence"</p>
              </span>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://chromewebstore.google.com/detail/ikfpolbfdnihjnadfodochmagdagpbik' target='_blank'>Live</a>
              <p class='mt-[15px]'>Repo is private :)</a>
            </div>
            
            <div class='flex flex-col justify-start items-center'>
              <span class='hover:bg-gray-600  p-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                <img class='object-contain w-[400px] h-[200px]' src='public/ebex-api.png'/>
              <p>eBex API - Python + Flask</p>
              <p class="italic text-lg">"API that is intended for my </br> 
              ebextractor but it is a free to use API"
              </p>
              </span>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://ebextractor-v1.vercel.app/api/extract/using_keyword?q=shoes' target='_blank'>Live</a>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://github.com/koribot/ebextractor-api-flask' target='_blank'>Repo</a>
            </div>

            <div class='flex flex-col justify-start items-center'>
              <span class='hover:bg-gray-600 p-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                <img class='object-contain w-[400px] h-[200px]' src='public/koribotjs.png'/>
              <p>\u{1F525}koribotJs\u{1F525}</p>
              <p class="italic text-lg">"An UN-OPTIMIZED MESSY Javascript front-end framework/library"
              </p>
              </span>
              <p class='mt-[15px] border px-[5px] hover:bg-gray-500'>NO WEBSITE YET</p>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://github.com/koribot/koribotJS' target='_blank'>Repo</a>
            </div>


            <div class='flex flex-col justify-start items-center'>
              <span class='hover:bg-gray-600 p-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                <img class='object-contain w-[400px] h-[200px]' src='public/ebex-web.png'/>
              <p>eBex Web Scraper</p>
              <p class="italic text-lg">"A nextjs web version of my chrome extension - UNDER \u{1F6A7}"
              </p>
              </span>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://ebex-scraper-web.vercel.app' target='_blank'>Live</a>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://github.com/koribot/ebex-scraper-web' target='_blank'>Repo</a>
            </div>

            <div class='flex flex-col justify-start items-center'>
              <span class='hover:bg-gray-600 p-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                <img class='object-contain w-[400px] h-[200px]' src='public/waan-trading.png'/>
              <p>Waan Trading - Ecommerce</p>
              <p class="italic text-lg">\u{201C}A simple ecommerce website using react - Frontend\u{201D} - UNDER \u{1F6A7}"
              </p>
              </span>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://waantrading-react.vercel.app' target='_blank'>Live</a>
              <a class='mt-[15px] border px-[5px] hover:bg-gray-500' href='prevReload-https://github.com/koribot/waantrading-react' target='_blank'>Repo</a>
            </div>

            <div class='flex flex-col justify-start items-center'>
              <span class='hover:bg-gray-600 p-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                <img class='object-contain w-[400px] h-[200px]' src='public/internship.png'/>
              <p>Internship Project - ACS-MEDISKIN-WEB</p>
              <p class="italic text-lg">\u{201C}My Intership Project - React, TypeScript"
              </p>
              </span>
            </div>

          </div>
          <h1 class='text-white mt-[20px] lg:text-2xl'>${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("</Projects>")}</h1>
      </div>
   </div>

   <div class='separator'>
   </div>

   <div ref='certificates' class='px-[20px] lg:px-[60px] flex flex-col text-center justify-center items-center gap-5'>
    <div class='border border-gray-600 rounded p-[15px]'>
          <h1 class='mb-[10px] text-white lg:text-2xl'>${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("<Certificates>")}</h1>
          <div class='text-white grid lg:flex gap-5'>
              <div class='flex flex-col justify-start items-center'>
                  <span class='hover:bg-gray-600 px-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                    <img class='object-contain w-[400px] h-[200px]' src='public/ADUKASYON-CERTIFICATE.png'/>
                    <p>September 2023 - January 2024</p>
                    <p class="italic text-lg">"ADUKASYON PH CERTIFICATE"</p>
                  </span>
                  <button if-click='normalDisplay-openModal' class=' mt-[15px] border px-[5px] hover:bg-gray-500'>View</button>
              </div>
          </div>
          <h1 class='text-white mt-[20px] lg:text-2xl'>${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("</Certificates>")}</h1>
      </div>
   </div>


   <div class='separator'>
   </div>


   <div ref='contact' class='flex justify-center'>
      <div class="container mx-auto px-8 flex justify-center">
        <div class="three-d-container flex justify-center gap-8">
            <div class="bg-gray-800 text-white p-6 rounded-md shadow-md flex flex-col">
              <h1 class="lg:text-2xl text-center mb-5">
                ${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("<Contact>")}
              </h1>
                <h2 class="text-xl font-semibold mb-4">Let's Connect!</h2>
                <p class="mb-4">Feel free to reach out. I'd love to hear from you!</p>
                <p class="mb-2">Contact me at:</p>
                <ul class="list-disc pl-5">
                    <li>Email: w.cawasa@gmail.com</li>
                    <li>
                      Facebook: <a class='ml-1 cursor-pointer underline' href='prevReload-https://www.facebook.com/wcawasa' target='_blank'> @wcawasa</a>
                    </li>
                    <li>
                      Github: <a class='ml-1 cursor-pointer underline' href='prevReload-https://github.com/koribot' target='_blank'> @koribot</a>
                     </li>
                </ul>
              <h1 class="lg:text-2xl mt-5 text-center">
                ${(0, $b0bcef696ab6225e$export$21a5ca8aa77d35ff)("</Contact>")}
              </h1>
            </div>
        </div>

      </div>
   </div>
   <div class='separator'> 
   </div>
   <div if-click='normalDisplay-scrollToTop' class='cursor-pointer text-white fixed bottom-5 right-0 lg:right-2'><img class='w-[50px] h-[50px]' src='public/arrow-up.png'/></div>
  </div>
 `;
};
var $9888e359c105ea28$export$2e2bcd8739ae039 = $9888e359c105ea28$export$839b001adf59c171;





if (window.localStorage.getItem("window") === null) window.localStorage.setItem("window", "pc");
const $e73bf42412feb220$var$mediaQuery = window.matchMedia("(min-width: 700px)");
(0, $35da740d59af89ba$export$5d769817e78da168)($e73bf42412feb220$var$mediaQuery);
const $e73bf42412feb220$export$729c8b7179294ba = ()=>{
    return `
  <div class='${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? "bg-[#232b2b]" : "bg-[#121313]"} min-h-[100vh] h-full'>
     ${window.localStorage.getItem("window") ? window.localStorage.getItem("window") === "pc" ? (0, $6bd3eda98fbd2e39$export$549ff81930776885)() : "" : window.localStorage.setItem("window", "pc")}
     ${(0, $c39e3576846451ff$export$2e2bcd8739ae039)()}
     ${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? (0, $2e936ac5cc761cfa$export$2e2bcd8739ae039)() : ""}
     ${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "normal" ? (0, $9888e359c105ea28$export$2e2bcd8739ae039)() : ""}
     ${(0, $1235afba39e73349$export$2e2bcd8739ae039)()}
  </div>
`;
};
var $e73bf42412feb220$export$2e2bcd8739ae039 = $e73bf42412feb220$export$729c8b7179294ba;





const $785050c3b6c81abb$var$path = "file:///src/Pages/About.js".replace("file://", "").split("/");
$785050c3b6c81abb$var$path.pop(); // Remove the filename
const $785050c3b6c81abb$var$basePath = $785050c3b6c81abb$var$path.join("/");
const $785050c3b6c81abb$export$c8424c4d8ba2150 = ()=>{
    return `
   <div class="bg-gradient-to-r min-h-[100vh] from-[#232b2b] to-[#232b2b] p-8 rounded-md shadow-md p-8 rounded-md shadow-md w-full animate__animated animate__fadeIn">
      <div class='flex mb-5'>
        <div>
          <div class="typewriter w-[fit-content]">
              <span>H</span>
              <span>e</span>
              <span>l</span>
              <span>l</span>
              <span>o</span>
          </div>
        </div>
      </div>

     <div class="mb-6">
       <h2 class="text-xl font-semibold mb-2 text-white">A Bit About Me</h2>
       <p class="text-gray-100">
        <ul class='flex flex-col text-white'>
          <li>- I am an aspiring web developer</li>
          <li>- I like to build stuffs</li>
        </ul>
       </p>
       <p class="text-white mt-[15px] italic text-lg">"Not the brightest but resourceful"</p>

     </div>


     <div class="mb-6">
       <h2 class="text-xl font-semibold mb-2 text-white">Tech Stack</h2>
       <p class="text-gray-100">
        <ul class='flex  text-white gap-5 mt-5'>
          <li class='flex items-center'><img class='w-[50px] h-[50px]' src="public/html.png"/></li>
          <li class='flex items-center'><img class='w-[50px] h-[50px]' src="public/tailwind.png"/></li>
          <li class='flex items-center'><img class='w-[50px] ' src="public/css.png"/></li>
          <li class='flex items-center'><img class='rounded w-[50px] h-[50px]' src="public/jscript.png"/></li>
          <li class='flex items-center'><img class='rounded w-[50px] h-[50px]' src="public/react.png"/></li>
          <li class='flex items-center'><img class='rounded w-[50px] h-[50px]' src="public/nextjs.png"/></li>
          <li class='flex items-center'><img class='rounded w-[50px] h-[50px]' src="public/python.png"/></li>
        </ul>
       </p>
     </div>

     <div class="mb-6 text-white">
       <h2 class="text-xl font-semibold mb-2 text-white">Contacts</h2>
       <p class="text-gray-100">Email: w.cawasa@gmail.com</p>
       <p>
        Facebook: <a class='ml-1' href='prevReload-https://www.facebook.com/wcawasa' target='_blank'> @wcawasa</a>
       </p>
       <p>
        Github: <a class='ml-1' href='prevReload-https://github.com/koribot' target='_blank'> @koribot</a>
       </p>
     </div>

    
     ${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? (0, $2e936ac5cc761cfa$export$2e2bcd8739ae039)() : ""}
   </div>
 `;
};
var $785050c3b6c81abb$export$2e2bcd8739ae039 = $785050c3b6c81abb$export$c8424c4d8ba2150;


const $ff1700c7350b43dc$export$271f9f08425019c7 = ()=>{
    const underConstruction = [
        "/projects/eBextractor",
        "/projects/ebex-api",
        "/projects/koribotjs"
    ];
    // console.log(underConstruction.find('/projects/koribotjs'))
    const location = window.location.pathname;
    return `
 <div class='flex bg-[#232b2b] items-center justify-center h-screen'>
  <div class="text-white text-center flex flex-col items-center justify-center ">
    <h1 class="text-4xl font-bold mb-4">404 - Not Found</h1>
    <p class="text-lg flex">The page <span class="text-red-500 font-bold mx-2">${location.substring(1)}</span> doesn't exist.</p>
    <p class='mt-[5px] flex text=[15px] gap-[5px]'>Go<a class='text-[green]'href='/'>Home</a>Instead</p>
    
  </div>
 </div>
 `;
};
var $ff1700c7350b43dc$export$2e2bcd8739ae039 = $ff1700c7350b43dc$export$271f9f08425019c7;






const $041094a82e49d805$var$ProjectsLists = [
    {
        name: "eBextractor",
        repo: "",
        live: "https://chromewebstore.google.com/detail/ikfpolbfdnihjnadfodochmagdagpbik",
        desc: `
\u{1F50D} The eBay Search Data Extraction Extension offers data analysis 
    for single-page search results, providing valuable insights through the following features:

- \u{1F4B0} Highest Price: Obtain the maximum price observed in the search results.
- \u{1F4B5} Lowest Price: Identify the minimum price found among the listings.
- \u{1F4CA} Average Price: Calculate the mean price across the search results.
- \u{1F3AF} Middle Price: Determine the median price, offering a representative value.
- \u{1F511} Keyword Occurrence: Track and quantify the frequency of each keyword throughout the listings.
- \u{1F4B2} Price Occurrence: Gain an understanding of how often different price points appear in the search results.
`
    },
    {
        name: "eBex - API",
        repo: "https://github.com/koribot/ebextractor-api-flask",
        live: "https://ebextractor-v1.vercel.app/api/extract/using_keyword?q=shoes",
        desc: `
 API that is intended for my ebextractor but it is a free to use API
`
    },
    {
        name: "koribotJS",
        repo: "https://github.com/koribot/koribotJS",
        live: "#",
        desc: `
  koribotJS is a hobby project, it is unoptimized, messy Component Based 
  Javascript framework/library. 
  - It uses diffing, patching and rendering algorigthm
  - It has a globalize state manager that is persistent until reload of the browser
  - a simple routing
  

   This portfolio is powered by it. 
`
    },
    {
        name: "eBex Web Scraper",
        repo: "https://github.com/koribot/ebex-scraper-web",
        live: "https://ebex-scraper-web.vercel.app",
        desc: `
    A nextjs web version of my chrome extension - UNDER \u{1F6A7}. `
    },
    {
        name: "Waan Trading - Ecommerce",
        repo: "https://github.com/koribot/waantrading-react",
        live: "https://waantrading-react.vercel.app",
        desc: `
    A simple ecommerce website using react - UNDER \u{1F6A7}. `
    }
];
const $041094a82e49d805$export$ca6fbb51b35e375c = ()=>{
    return `
   <div class="bg-gradient-to-r min-h-[100vh] from-[#232b2b] to-[#232b2b] p-8 rounded-md shadow-md p-8 rounded-md shadow-md w-full animate__animated animate__fadeIn">
      <div class='flex mb-5'>
        <div class="typewriter">
            <span>P</span>
            <span>r</span>
            <span>o</span>
            <span>j</span>
            <span>e</span>
            <span>c</span>
            <span>t</span>
            <span>s</span>
        </div>
      </div>

    ${$041094a82e49d805$var$ProjectsLists.map((project)=>{
        return `
      <div class="mb-8">
          <div class="bg-black p-6 rounded-md shadow-md">
            <h2 class="text-xl font-semibold mb-2 text-white">${project.name}</h2>
            <pre class="text-gray-100 mb-4">${project.desc}</pre>
            <div class="flex">
              ${project.repo ? `<a class="text-blue-500 mr-4" href="prevReload-${project.repo}" target="_blank">Repository</a>` : ""}
              ${project.live ? `<a class="text-green-500" href="prevReload-${project.live}" target="_blank">Live Demo</a>` : ""}
            </div>
          </div>
        </div>
      `;
    })}
     ${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? (0, $2e936ac5cc761cfa$export$2e2bcd8739ae039)() : ""}
   </div>
 `;
};
var $041094a82e49d805$export$2e2bcd8739ae039 = $041094a82e49d805$export$ca6fbb51b35e375c;




const $6a6f52cc277c798b$export$c39d74429c80a86b = ()=>{
    return `
 <div class='bg-gradient-to-r min-h-[100vh] from-[#232b2b] to-[#232b2b] p-8 rounded-md shadow-md p-8 rounded-md shadow-md w-full animate__animated animate__fadeIn'>
   <div>
    <p class='text-white text-[20px] mb-[15px] italic'>Certificates</p>
   </div>
   <div>
    <div class='border border-gray-600 rounded p-[15px]'>
          <div class='text-white grid lg:flex gap-5'>
              <div class='flex flex-col justify-start items-center'>
                  <span class='hover:bg-gray-600 px-5 flex flex-col gap-[5px] rounded justify-center items-center'>
                    <img class='object-contain w-[400px] h-[200px]' src='public/ADUKASYON-CERTIFICATE.png'/>
                    <p>September 2023 - January 2024</p>
                    <p class="italic text-lg">"ADUKASYON PH CERTIFICATE"</p>
                  </span>
                  <button if-click='normalDisplay-openModal' class=' mt-[15px] border px-[5px] hover:bg-gray-500'>View</button>
              </div>
          </div>
    </div>

     ${(0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd" ? (0, $2e936ac5cc761cfa$export$2e2bcd8739ae039)() : ""}
   </div>
 </div>
 `;
};
var $6a6f52cc277c798b$export$2e2bcd8739ae039 = $6a6f52cc277c798b$export$c39d74429c80a86b;


const $8b488dbcce1c14ef$export$66b32f6f30eb4b4 = ()=>{
    const currentLocation = window.location.pathname;
    let routes = {};
    if ((0, $0d4230ba56185297$export$b782dad1d219cf26).mode.mode === "cmd") routes = {
        "/": (0, $e73bf42412feb220$export$2e2bcd8739ae039),
        "/about": (0, $785050c3b6c81abb$export$2e2bcd8739ae039),
        "/projects": (0, $041094a82e49d805$export$2e2bcd8739ae039),
        "/certificates": (0, $6a6f52cc277c798b$export$2e2bcd8739ae039)
    };
    else routes = {
        "/": (0, $e73bf42412feb220$export$2e2bcd8739ae039)
    };
    return routes[currentLocation] ? routes[currentLocation] : (0, $ff1700c7350b43dc$export$2e2bcd8739ae039);
};
var $8b488dbcce1c14ef$export$2e2bcd8739ae039 = $8b488dbcce1c14ef$export$66b32f6f30eb4b4;



const $35da740d59af89ba$var$createVirtualApp = ()=>(0, $efb5c0fd3ddbf6a4$export$2e2bcd8739ae039)((0, $8b488dbcce1c14ef$export$2e2bcd8739ae039)()() // routes returns a component(function) that needs to be called '()' so processHTML(htmlString) can process it
    );
let $35da740d59af89ba$var$virtualApp = $35da740d59af89ba$var$createVirtualApp(0); // A virtual App/DOM Tree
const $35da740d59af89ba$var$realApp = (0, $1ae97e72b61d2374$export$2e2bcd8739ae039)($35da740d59af89ba$var$virtualApp); // A real DOM Tree
let $35da740d59af89ba$var$$rootEl = (0, $5fed3ec5398ad2d0$export$2e2bcd8739ae039)($35da740d59af89ba$var$realApp, document.getElementById("kori-root")); // Mount the Real DOM tree to root
// window.addEventListener('resize', function (e) {
//   if (window.innerWidth > 700) {
//     var currentMode = window.localStorage.getItem('mode');
//     if (currentMode) {
//       window.localStorage.setItem('mode', currentMode)
//       window.localStorage.setItem('window', 'pc')
//       setState(
//         'mode',
//         {
//           mode: currentMode,
//           windowSize: 'pc'
//         }
//       )
//     }
//   } else {
//     var currentMode = window.localStorage.getItem('mode');
//     if (currentMode) {
//       window.localStorage.setItem('mode', currentMode)
//       window.localStorage.setItem('window', 'phone')
//       setState(
//         'mode',
//         {
//           mode: "normal",
//           windowSize: 'phone'
//         }
//       )
//     }
//   }
// });
// Define a media query (e.g., for screens larger than 768px)
const $35da740d59af89ba$var$mediaQuery = window.matchMedia("(min-width: 700px)");
function $35da740d59af89ba$export$5d769817e78da168(event) {
    if (event.matches) {
        const currentMode = window.localStorage.getItem("mode");
        if (currentMode) {
            window.localStorage.setItem("mode", currentMode);
            window.localStorage.setItem("window", "pc");
            (0, $0d4230ba56185297$export$42fffed799c298bb)("mode", {
                mode: currentMode,
                windowSize: "pc"
            });
        } else {
            window.localStorage.setItem("mode", "cmd");
            window.localStorage.setItem("window", "pc");
        }
    } else {
        window.localStorage.setItem("mode", "normal");
        window.localStorage.setItem("window", "phone");
        (0, $0d4230ba56185297$export$42fffed799c298bb)("mode", {
            mode: "normal",
            windowSize: "phone"
        });
    }
}
$35da740d59af89ba$var$mediaQuery.addEventListener("change", $35da740d59af89ba$export$5d769817e78da168);
$35da740d59af89ba$export$5d769817e78da168($35da740d59af89ba$var$mediaQuery);
// Acts as a renderer of the virtualApp when state changes, this is triggred everytime you use setState function or using router
(0, $0d4230ba56185297$export$2e2bcd8739ae039).track.start = async ()=>{
    const vNewApp = await $35da740d59af89ba$var$createVirtualApp();
    const patch = (0, $be0f08cdfe6eb2e3$export$2e2bcd8739ae039)(await $35da740d59af89ba$var$virtualApp, await vNewApp);
    $35da740d59af89ba$var$$rootEl = patch($35da740d59af89ba$var$$rootEl);
    $35da740d59af89ba$var$virtualApp = vNewApp;
};


//# sourceMappingURL=index.afba806a.js.map
